module.exports = __webpack_public_path__ + "img/work_icon_match.8e82d7d2.svg";